import { useEffect } from "react";
import { ArrowLeft } from "lucide-react";

const sections = [
  {
    id: "about",
    title: "About these terms",
    body: [
      "These terms govern donations made to AvdheshanandG Mission (“AGM”, “we”, “us”) through this website. By making a donation, you agree to these terms.",
    ],
  },
  {
    id: "nature",
    title: "Nature of donations",
    body: [
      "Donations are voluntary contributions in support of AGM's charitable work. They are not made in exchange for any goods, services or benefits.",
    ],
  },
  {
    id: "responsibilities",
    title: "Donor responsibilities",
    body: [
      "You agree to provide accurate information and to use only a payment method you are authorised to use.",
    ],
  },
  {
    id: "payments",
    title: "Payments and donor region",
    body: [
      "Donations are processed through trusted payment partners — Razorpay for donations within India (INR) and Stripe for donations from the United States (USD). You may select your donor region before completing payment; the region determines the currency and payment provider.",
    ],
  },
  {
    id: "receipts",
    title: "Acknowledgements",
    body: [
      "An acknowledgement of your contribution is emailed to you. This is an acknowledgement of your gift, not a tax-exemption certificate; any statutory tax receipt, where applicable, is issued separately.",
    ],
  },
  {
    id: "refunds",
    title: "Refunds and cancellations",
    body: [
      "Refunds and cancellations are handled in accordance with our Refund & Cancellation Policy, available at /refund-policy.",
    ],
  },
  {
    id: "liability",
    title: "Limitation of liability",
    body: [
      "To the extent permitted by law, AGM is not liable for indirect, incidental or consequential losses arising from use of this website. This does not limit any liability that cannot be excluded under applicable law.",
    ],
  },
  {
    id: "governing-law",
    title: "Governing law",
    body: [
      "These terms are governed by the laws of India. The courts of Delhi, India shall have exclusive jurisdiction over any dispute arising from them.",
    ],
  },
  {
    id: "contact",
    title: "Contact",
    body: ["For any question about these terms, write to info@avdheshanandgmission.org."],
  },
];

export default function Terms() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-b from-[#fcf9f5] to-white">
      <div className="relative flex h-[44vh] items-center justify-center overflow-hidden bg-[#7B0000] text-white">
        <div className="relative z-20 px-4 text-center">
          <h1 className="mb-4 mt-7 font-serif text-4xl md:text-6xl">Terms &amp; Conditions</h1>
          <p className="mx-auto max-w-3xl text-lg font-light md:text-2xl">
            The terms that apply to donations made through this website.
          </p>
        </div>
        <div className="absolute bottom-4 right-4 z-10 font-serif text-6xl text-white/20">ॐ</div>
      </div>

      <div className="container mx-auto px-4 py-8">
        <a
          href="/"
          className="mb-8 inline-flex items-center text-[#B82A1E] transition-colors duration-300 hover:text-[#8a1f16]"
        >
          <ArrowLeft size={20} className="mr-2" />
          Back to home
        </a>

        <div className="mx-auto max-w-3xl space-y-10 pb-16">
          {sections.map(section => (
            <section key={section.id} id={section.id}>
              <h2 className="mb-3 text-2xl font-semibold text-[#14201f]">{section.title}</h2>
              {section.body.map((p, i) => (
                <p key={i} className="mb-3 text-base leading-8 text-[#52615f]">
                  {p}
                </p>
              ))}
            </section>
          ))}
        </div>
      </div>
    </div>
  );
}
